/* @flow */
// typecheck: ignore file
import { combineReducers } from 'redux';
import type { Reducer } from 'redux';

import connectedBankAccountRequest from 'reducers/connectedBankAccountRequest';
import roleBasedMessagingSearch from 'reducers/roleBasedMessagingSearch';
import activityRecipients from 'payments/reducers/activityRecipients';
import groupQuickSwitcher from 'groups/reducers/groupQuickSwitcher';
import organizationClassesTables from 'reducers/organizationClassesTables';
import connectionStateBanner from 'reducers/connectionStateBanner';
import tables from 'reducers/tables';
import banners from 'reducers/banners';
import toasts from 'reducers/toasts';
import zopim from 'reducers/zopim';
import recentMessagesModal from 'reducers/recentMessagesModal';
import availableReactions from 'reducers/availableReactions';
import quickActions from 'reducers/quickActions';
import peopleTables from 'reducers/peopleTables';
import schoolTables from 'reducers/schoolTables';
import joyrides from 'reducers/joyrides';

const globalReducers = {
  connectedBankAccountRequest,
  roleBasedMessagingSearch,
  connectionStateBanner,
  organizationClassesTables,
  groupQuickSwitcher,
  activityRecipients,
  schoolTables,
  banners,
  toasts,
  zopim,
  tables,
  recentMessagesModal,
  availableReactions,
  quickActions,
  peopleTables,
  joyrides,
};

export default function combineRemindReducers(apolloReducer: Reducer<*, *>) {
  return combineReducers({
    ...globalReducers,
    apollo: apolloReducer,
  });
}



// WEBPACK FOOTER //
// ./src/reducer.js